/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfNavigationItemDto } from '../../models/platform-api-result-of-navigation-item-dto';
import { PlatformChangeNavigationItemConfiguration } from '../../models/platform-change-navigation-item-configuration';

export interface PostNavigationitemsActionChangeconfiguration$Params {
      body: PlatformChangeNavigationItemConfiguration
}

export function postNavigationitemsActionChangeconfiguration(http: HttpClient, rootUrl: string, params: PostNavigationitemsActionChangeconfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
  const rb = new RequestBuilder(rootUrl, postNavigationitemsActionChangeconfiguration.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfNavigationItemDto>;
    })
  );
}

postNavigationitemsActionChangeconfiguration.PATH = '/api/navigationitems/action/changeconfiguration';
